import { useEffect, useState } from "react";
import { useSearchParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { API } from "../App";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const tokenParam = params.get("token");

  const [status, setStatus] = useState("loading"); // loading | ok | error
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (!tokenParam) {
      setStatus("error");
      setMessage("Missing token.");
      return;
    }

    axios
      .get(`${API}/auth/verify-email?token=${encodeURIComponent(tokenParam)}`)
      .then((res) => {
        // Backend MAY return only {message} or may return {message, token, user}
        const token = res.data?.token;
        const user = res.data?.user;

        setStatus("ok");
        setMessage(res.data?.message || "Email verified!");

        // ✅ If backend sends token+user → auto login + go to dashboard
        if (token && user) {
          localStorage.setItem("token", token);
          localStorage.setItem("user", JSON.stringify(user));

          // ✅ Force App to re-check auth in same tab
          window.dispatchEvent(new StorageEvent("storage", { key: "token" }));

          setTimeout(() => navigate("/crm", { replace: true }), 600);
          return;
        }

        // ✅ If backend DOES NOT send token/user → send to login
        setTimeout(() => navigate("/", { replace: true }), 1200);
      })
      .catch((err) => {
        setStatus("error");
        setMessage(err.response?.data?.detail || "Verification failed.");
      });
  }, [tokenParam, navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        background: "#F9F9F7",
        padding: 24,
      }}
    >
      <div style={{ width: "100%", maxWidth: 520, background: "white", borderRadius: 12, padding: 24 }}>
        <h2 style={{ marginTop: 0, color: "#1A4D2E" }}>Verify Email</h2>

        {status === "loading" && <p>Verifying…</p>}

        {status === "ok" && (
          <>
            <p>{message}</p>
            <p style={{ color: "#6B7280", fontSize: 14 }}>Redirecting…</p>

            <div style={{ display: "flex", gap: 12, marginTop: 12 }}>
              <Link to="/crm" style={{ color: "#1A4D2E", fontWeight: 600 }}>
                Go to Dashboard
              </Link>
              <Link to="/" style={{ color: "#1A4D2E", fontWeight: 600 }}>
                Go to Login
              </Link>
            </div>
          </>
        )}

        {status === "error" && (
          <>
            <p style={{ color: "crimson" }}>{message}</p>
            <Link to="/" style={{ color: "#1A4D2E", fontWeight: 600 }}>
              Back to Login
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
